export default __webpack_public_path__ + "static/media/portfolio-182.aa43fba5.jpg";